import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fb-fields',
  templateUrl: './fb-fields.component.html',
  styleUrls: ['./fb-fields.component.css']
})
export class FbFieldsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
